import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import { useDispatch, useSelector } from 'react-redux';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';

import {
  CoreLink,
  Hamburger,
} from '../../../components';

import './style.scss';

const NavigationCampaignMenu = ({ campaignMenuId }) => {
  const dispatch = useDispatch();
  const shouldshowNavMenu = useSelector((state) => state.getIn(['uiInternal', 'showNavMenu']));

  const onHamburgerClick = () => {
    if (shouldshowNavMenu) {
      dispatch(hideNavMenu());
    } else {
      dispatch(showNavMenu());
    }
  };

  return (
    <>
      <div className="NavigationCampaign__desktop">
        <Menu id={campaignMenuId}>
          {(items) => {
            return (
              <div className="NavigationCampaign__menu">
                {items.map((item) => {
                  if (item) {
                    const title = item.getIn(['link', 'title'], 'Untitled');
                    const url = item.getIn(['link', 'url'], '');

                    return (
                      <div key={title} className="NavigationCampaign__menu__item">
                        <CoreLink className="NavigationCampaign__menu__item__link" to={url}>
                          <div className="NavigationCampaign__menu__item__title">{title}</div>
                        </CoreLink>
                      </div>
                    );
                  }
                })}
              </div>
            );
          }}
        </Menu>
      </div>
      <div className="NavigationCampaign__mobile">
        <Hamburger handleClick={onHamburgerClick} />
        <div className="NavigationCampaign__mobile__inner">
          <div className="NavigationCampaign__mobile__menu">
            <Menu id={campaignMenuId}>
              {(items) => {
                return (
                  <div className="NavigationCampaign__mobile__menu__menu">
                    {items.map((item) => {
                      if (item) {
                        const title = item.getIn(['link', 'title'], 'Untitled');
                        const url = item.getIn(['link', 'url'], '');

                        return (
                          <div key={title} className="NavigationCampaign__mobile__menu__item">
                            <CoreLink className="NavigationCampaign__mobile__menu__item__link" to={url}>
                              <div className="NavigationCampaign__mobile__menu__item__title">{title}</div>
                            </CoreLink>
                          </div>
                        );
                      }
                    })}
                  </div>
                );
              }}
            </Menu>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavigationCampaignMenu;
